import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{
  isOpen: boolean
  isChangingTitle: boolean
  isEmpty: boolean
}>`
  display: flex;
  justify-content: space-between;
  ${({ isOpen, isChangingTitle, isEmpty }) =>
    isOpen || isChangingTitle || isEmpty
      ? css`
          > div {
            width: calc(100% - 100px);
          }
          > div + div {
            width: 100px;
          }
        `
      : css`
          > div {
            width: calc(100% - 370px);
          }
          > div + div {
            width: 370px;
          }
        `}
`

export const Title = styled.div`
  display: flex;
  div + button {
    color: #363636 !important;
  }
  input {
    padding: 4px 8px;
    margin-left: 13px;
    border-color: #213f68 !important;
    box-shadow: 0px 0px 0px 4px #213f683d !important;
  }
  input + button {
    opacity: 0;
  }
  button {
    padding: 0 5px;
    border: none;
    box-shadow: none;
    color: #213f68 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.7;
    }
  }
  div {
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    color: #213f68;
    padding: 2px 8px;
    margin-right: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: 200ms;
    &:hover {
      opacity: 0.7;
    }
  }
`

export const Actions = styled.div`
  display: flex;
  justify-content: end;
  button {
    border: none;
    box-shadow: none;
    border-radius: 8px;
    padding: 0 10px;
    margin-left: 16px;
    color: #757575 !important;
    background-color: #f0f0f0 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.48;
      svg {
        opacity: 1;
      }
    }
  }
  button + button {
    padding: 0 5px;
    color: #213f68 !important;
    background-color: white !important;
  }
`
